'use client';

import React from 'react';
import { cn } from '@/lib/utils/utils';
import JContainer from './JContainer';

interface JSectionBaseProps {
    ref?: React.RefObject<HTMLDivElement | null>;
    id?: string;
    as?: 'section' | 'div' | 'main' | 'article';
    spacing?: 'sm' | 'md' | 'lg' | 'xl' | 'none';
    className?: string;
    style?: React.CSSProperties;
    // JContainer的所有props
    size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
    padding?: 'sm' | 'md' | 'lg' | 'none' | 'blog';
    containerClassName?: string;
}

type JSectionProps = React.PropsWithChildren<JSectionBaseProps>;

/**
 * JSection - Join Intelligence 统一区块组件
 *
 * 封装了 section + JContainer 的常见组合模式
 *
 * @param as - HTML标签类型，默认section
 * @param spacing - 垂直间距: sm, md, lg, xl, none
 * @param size - 传递给JContainer的尺寸
 * @param padding - 传递给JContainer的内边距
 * @param containerClassName - JContainer的额外类名
 * @param className - Section的额外类名
 * @param ref - 可选的DOM引用
 * @param children - 子元素
 */
export default function JSection({
    ref,
    id,
    as = 'section',
    spacing = 'md',
    className = '',
    style,
    children,
    // JContainer props
    size = 'full',
    padding = 'none',
    containerClassName = '',
}: JSectionProps) {
    // 垂直间距映射 - 基于项目中的实际使用模式
    const spacingClasses = {
        none: '',
        sm: 'py-[40px] sm:py-[60px]', // 小间距
        md: 'py-[60px] sm:py-[120px]', // 标准间距
        lg: 'py-[80px] sm:py-[160px]', // 大间距
        xl: 'py-[100px] sm:py-[200px]', // 特大间距
    };

    const Component = as;

    return (
        <Component
            ref={ref}
            id={id}
            style={style}
            className={cn(spacingClasses[spacing], className)}
        >
            <JContainer
                size={size}
                padding={padding}
                className={containerClassName}
            >
                {children}
            </JContainer>
        </Component>
    );
}
